export const getContracts = (state) => state.contracts
export const getContractTypes = (state) => state.types
